import React from "react";
import { useParams } from "react-router-dom";
import ResetPin from "./resetPin";

function ResetPinWithParams(props) {
  const { token } = useParams();
  return <ResetPin {...props} token={token} />;
}

export default ResetPinWithParams;